import { render, staticRenderFns } from "./Staffing.vue?vue&type=template&id=5a38a2cf&"
import script from "./Staffing.vue?vue&type=script&lang=ts&"
export * from "./Staffing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports